import React, { FC } from 'react';
import { Step2CreateDefault } from './step-2-create-default';
import { Step2CreatePrevious } from './step-2-create-previous';

interface Step2Props {
    selectedOrganizationLocationId: number;
    onBack: () => void;
    onSubmit: () => void;
}

export const Step2: FC<Step2Props> = (props) => {
    const { selectedOrganizationLocationId, onBack, onSubmit } = props;

    return (
        <>
            {selectedOrganizationLocationId < 0 ? (
                <Step2CreateDefault
                onBack={onBack}
                onSubmit={onSubmit}
                />
            ) : (
                <Step2CreatePrevious
                    selectedOrganizationLocationId={selectedOrganizationLocationId}
                    onBack={onBack}
                    onSubmit={onSubmit}
                />
            )}
        </>
    );
};
